import { useMutation, useQueryClient } from "@tanstack/react-query";
import Clients from "core/api-clients";
import { ICreateUserRequestModel } from "@lib/types";
import { useStateContext } from "state";

const useCreateUser = () => {
  const queryClient = useQueryClient();
  const state = useStateContext();

  return useMutation({
    mutationFn: (requestModel: ICreateUserRequestModel) =>
      Clients.ManagementBackend.Users.create(requestModel),
    onSuccess: () => {
      if (state.user)
        queryClient.invalidateQueries(["listUsers", state.user.id]);
    },
  });
};

export default useCreateUser;
